import { EnableSwitch, SelectUser } from '../..';

export const userBlockListItemForm = [
  {
    fields: [
      {
        field: 'blockedUserId',
        width: ['100%'],
        component: SelectUser,
        componentProps: {},
      },
      {
        field: 'status',
        component: EnableSwitch,
        width: ['100%'],
      },
    ],
  },
];
